import { WorkOrderComplementTankLevel } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useEffect, useRef } from 'react';
import {
  ReportChecklistDamageData,
  ReportChecklistData,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';
import { checklistDamages } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.DamageConstant';
import { handlerImageCar } from '@/utils/functions/handlerImageCar';

interface Props {
  checklist?: ReportChecklistData;
  setLoaded?: (value: boolean) => void;
}

const tankLevel = {
  [WorkOrderComplementTankLevel.Full]: 8,
  [WorkOrderComplementTankLevel.SevenEights]: 7,
  [WorkOrderComplementTankLevel.ThreeQuarters]: 6,
  [WorkOrderComplementTankLevel.Half]: 5,
  [WorkOrderComplementTankLevel.Quarter]: 4,
  [WorkOrderComplementTankLevel.OneEight]: 3,
  [WorkOrderComplementTankLevel.Reserve]: 2,
  [WorkOrderComplementTankLevel.Empty]: 1,
};

const ReportChecklistDamage: React.FC<Props> = ({ checklist, setLoaded }) => {
  const carRef = useRef<SVGSVGElement>(null);
  const isBosch = checklist?.company?.bosch;

  useEffect(() => {
    if (carRef.current) {
      let i = 0;
      while (checklist?.damages && i < checklist?.damages.length) {
        setRect(checklist?.damages[i]);
        i = i + 1;
      }
    }
  }, [carRef]);

  function setRect(damage: ReportChecklistDamageData) {
    if (!carRef.current) return;

    const itemIndex = checklistDamages?.findIndex(
      (item) => item.value === damage.damage,
    );
    const damageCode = String(itemIndex + 1).padStart(2, '0');

    const svgns = 'http://www.w3.org/2000/svg';

    const g = document.createElementNS(svgns, 'g');
    const rect = document.createElementNS(svgns, 'rect');

    const x = damage.x - 15;
    const y = damage.y - 15;

    g.setAttribute('x', x.toString());
    g.setAttribute('transform', `matrix(1, 0, 0, 1, ${x}, ${y})`);
    g.classList.add('car-damage');

    rect.setAttribute('rx', '15');
    rect.setAttribute('ry', '15');

    const text = document.createElementNS(svgns, 'text');
    text.setAttribute('x', '15');
    text.setAttribute('y', '16');
    text.setAttribute('text-anchor', 'middle');
    text.setAttribute('dominant-baseline', 'middle');
    text.setAttribute('fill', 'black');
    const textNode = document.createTextNode(damageCode);

    text.appendChild(textNode);
    g.appendChild(rect);
    g.appendChild(text);
    carRef.current?.appendChild(g);
  }

  const svgProps = {
    ref: carRef,
    className: 'car-sides',
    style: { width: '100%', height: 'auto' },
    onLoad: () => !!setLoaded && setLoaded(true),
  };

  return (
    <div className="reportChecklist-damage">
      <div
        className={`reportChecklist-damage-header ${isBosch ? 'is-bosch' : ''}`}
      >
        <span>Marcas e observações na carroceria</span>
      </div>

      <div className="reportChecklist-damage-content">
        <div className="row">
          <div className="mid vehicle-image">
            {handlerImageCar(svgProps, checklist?.vehicle?.type)}
          </div>
          <div className="mid">
            <ol>
              <li>Amassado</li>
              <li>Quebrado</li>
              <li>Rasgado</li>
              <li>Riscado</li>
              <li>Trincado</li>
              <li>Furado</li>
              <li>Sujo</li>
              <li>Arranhão Superficial</li>
              <li>Arranhão Profundo</li>
              <li>Fezes de Aves/Mancha de Inseto</li>
              <li>Pintura Áspera</li>
              <li>Over Spray</li>
              <li>Chuva Ácida</li>
              <li>Marcas de Lixa</li>
              <li>Batido de Pedra</li>

              <li>Desplacamento de Verniz</li>
              <li>Contaminação Ferrosa</li>
              <li>Moldura/Friso Solto</li>
              <li>Defeito Desc</li>
              <li>Pintura sem Aderência</li>
              <li>Cola de Plotagem</li>
              <li>Repintura com Diferença de Cor</li>
              <li>Verniz Mal Curado</li>
              <li>Verniz Cerâmico</li>
              <li>Verniz Convencional</li>
              <li>Aplicação de Coach</li>
              <li>Couro Danificado</li>
              <li>Mancha no Carpete</li>
            </ol>
          </div>
        </div>
      </div>

      <div className="reportChecklist-tankLevel-root">
        <strong>Nível do tanque</strong>

        <div className="reportChecklist-tankLevel-wrapper">
          <table className="reportChecklist-tankLevel-info">
            <thead>
              <tr>
                <th>
                  <span>C</span>
                </th>
                <th>
                  <span>7/8</span>
                </th>
                <th>
                  <span>3/4</span>
                </th>
                <th>
                  <span>1/2</span>
                </th>
                <th>
                  <span>1/4</span>
                </th>
                <th>
                  <span>1/8</span>
                </th>
                <th>
                  <span>R</span>
                </th>
                <th>
                  <span>V</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <div
            className={`reportChecklist-tankLevel-progress tank-${
              checklist?.worKOrder?.tankLevel
                ? tankLevel[checklist?.worKOrder?.tankLevel]
                : 0
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default ReportChecklistDamage;
